var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},_vm._l((_vm.alerts),function(alert){return _c('b-alert',{key:alert.title,attrs:{"show":"","variant":alert.type,"dismissible":""}},[_c('strong',[_vm._v(_vm._s(alert.title)+":")]),_vm._v(" "+_vm._s(alert.msg)+"\n            ")])}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }